import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiFeesService() {
  return fetch(`fees/link_payment`, {
    method: 'GET',
    ms: 'PDV',
    auth: true,
  });
}
